import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import Icon from "../Icon/Icon";
import Spinner from "../Spinner";
import { Text } from "../Text";
import { UnstyledLink } from "../UnstyledLink";
import FocusHandler from "../handler/FocusHandler";
import { AlignBox, AlignTarget } from "../Align";

var ButtonLink = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonLink, _React$Component);

  var _super = _createSuper(ButtonLink);

  function ButtonLink() {
    var _this;

    _classCallCheck(this, ButtonLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.node = void 0;

    _this.buttonLinkRef = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass(ButtonLink, [{
    key: "focus",
    value: function focus() {
      if (this.node) {
        this.node.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          disabled = _this$props.disabled,
          disabledWhenPending = _this$props.disabledWhenPending,
          display = _this$props.display,
          hideLabel = _this$props.hideLabel,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          label = _this$props.label,
          pending = _this$props.pending,
          size = _this$props.size,
          type = _this$props.type,
          wrap = _this$props.wrap,
          buttonLinkProps = _objectWithoutProperties(_this$props, ["className", "color", "disabled", "disabledWhenPending", "display", "hideLabel", "icon", "iconPosition", "label", "pending", "size", "type", "wrap"]);

      var isDisabled = disabled || pending && disabledWhenPending;
      var isInline = display === 'inline-flex';
      var buttonLinkClass = classNames('ButtonLink', className, {
        'Is--disabled': isDisabled,
        'ButtonLink--Is--disabled--white': isDisabled && color === 'white',
        IconParent: icon
      });
      var buttonLinkReverse = iconPosition === 'right';
      var buttonLinkIconMarginValues;

      if (label && size === 'large' && iconPosition === 'right') {
        buttonLinkIconMarginValues = {
          left: 8
        };
      } else if (label && size === 'large') {
        buttonLinkIconMarginValues = {
          right: 8
        };
      } else if (label && iconPosition === 'right') {
        buttonLinkIconMarginValues = {
          left: 4
        };
      } else if (hideLabel && icon) {
        buttonLinkIconMarginValues = {};
      } else if (label) {
        buttonLinkIconMarginValues = {
          right: 4
        };
      }

      var buttonLinkLabelHeightValues;
      var buttonLinkLabelSizeValues;

      if (size === 'small') {
        buttonLinkLabelHeightValues = 16;
        buttonLinkLabelSizeValues = 12;
      } else if (size === 'large') {
        buttonLinkLabelHeightValues = 24;
        buttonLinkLabelSizeValues = 16;
      } else {
        buttonLinkLabelHeightValues = 20;
        buttonLinkLabelSizeValues = 14;
      }

      var buttonLinkTextProps = {
        lineHeight: buttonLinkLabelHeightValues,
        size: buttonLinkLabelSizeValues,
        weight: 'medium'
      };
      var buttonLinkLabelColorValues = isDisabled || pending ? 'disabled' : color;
      var spinnerProps = {
        color: 'regular',
        size: 'small',
        margin: buttonLinkIconMarginValues
      };
      var renderIcon = icon && /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: buttonLinkLabelColorValues,
        margin: buttonLinkIconMarginValues,
        size: 12
      });
      return /*#__PURE__*/React.createElement(FocusHandler, null, function (inputMethodProps, inputMethod) {
        return /*#__PURE__*/React.createElement(AlignTarget, _extends({}, buttonLinkProps, {
          strategy: "baseline",
          size: buttonLinkLabelSizeValues,
          lineHeight: buttonLinkLabelHeightValues
        }), function (alignProps, isAligned) {
          return (
            /*#__PURE__*/
            // $FlowFixMe - go/flowfixme122
            React.createElement(UnstyledLink, _extends({}, inputMethodProps, buttonLinkProps, alignProps, {
              className: classNames(buttonLinkClass, // Firefox treats buttons as replaced elements, causing flex and
              // block buttons to treat the bottom of the node as its baseline.
              // We use inline-flex to circumvent this issue.
              // https://jsfiddle.net/x8v6bcaz/1/
              isAligned || isInline ? 'Flex-inlineFlex' : 'Flex-flex'),
              disabled: isDisabled,
              ref: _this2.buttonLinkRef,
              type: type,
              "data-input-method": inputMethod
            }), /*#__PURE__*/React.createElement(AlignBox, {
              reference: buttonLinkTextProps,
              reverse: buttonLinkReverse
            }, pending ? /*#__PURE__*/React.createElement(Spinner, _extends({
              flex: true
            }, spinnerProps)) : renderIcon, /*#__PURE__*/React.createElement(Text, {
              color: buttonLinkLabelColorValues,
              lineHeight: buttonLinkLabelHeightValues,
              size: buttonLinkLabelSizeValues,
              visuallyHidden: hideLabel,
              weight: "medium",
              wrap: wrap,
              className: "ButtonLink-label"
            }, label)))
          );
        });
      });
    }
  }]);

  return ButtonLink;
}(React.Component);

ButtonLink.defaultProps = {
  color: 'blue',
  display: 'flex',
  size: 'medium',
  type: 'button',
  wrap: false
};
export default ButtonLink;